import { Box } from "@mui/material";
import Button from "@mui/material/Button";
import { useEquipmentFilterStyles } from './EquipmentFilterButtonsStyles';

const EquipmentFilterButtons = ({
  type = "equipment",
  options,
  selectedEquipment,
  clickedEquipment,
  handleClickEquipment,
  removeAllClickedEquipment = () => {},
  addAllClickedEquipment = () => {},
  color = '#000'
}) => {
  const getEquipmentName = (id) => options.find(equipment => equipment.id === id)?.name || '';
  const isAllEquipmentClicked = selectedEquipment.some((equipmentId) => clickedEquipment.includes(equipmentId));

  const getSelectAllEquipmentName = () => {
    if (!selectedEquipment.length) {
      return `No ${type === 'equipment' ? 'Equipment' : 'Tags' } Selected`;
    }

    return isAllEquipmentClicked ? "Remove All" : "Select All";
  };

  return (
    <Box sx={{ display: 'flex', gap: "30px" }}>
      <Button
        variant={isAllEquipmentClicked ? 'contained' : 'outlined'}
        onClick={() => isAllEquipmentClicked ? removeAllClickedEquipment() : addAllClickedEquipment()}
        disabled={!selectedEquipment.length}
        sx={{
          ...useEquipmentFilterStyles.filterButton(isAllEquipmentClicked, color),
          ...useEquipmentFilterStyles.selectAllButton(!selectedEquipment.length),
        }}
      >
        {getSelectAllEquipmentName()}
      </Button>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
        {
          [...selectedEquipment].sort((a, b) => a - b)
            .map((equipmentId) => (
              <Button
                variant={clickedEquipment.includes(getEquipmentName(equipmentId)) ? 'contained' : 'outlined'}
                key={equipmentId}
                onClick={() => handleClickEquipment(getEquipmentName(equipmentId))}
                sx={useEquipmentFilterStyles.filterButton(clickedEquipment.includes(getEquipmentName(equipmentId)), color)}
              >
                {getEquipmentName(equipmentId)}
              </Button>
            ))
        }
      </Box>
    </Box>
  );
};

export default EquipmentFilterButtons;
